import { render, staticRenderFns } from "./NewAboutUs.vue?vue&type=template&id=1e69223d&scoped=true&"
import script from "./NewAboutUs.vue?vue&type=script&lang=js&"
export * from "./NewAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e69223d",
  null
  
)

export default component.exports